import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from 'recharts';

const ProgressTrendChart = ({
  data,
  title = '진행 추이',
  xKey = 'month',
  lineKey = 'proofs',
  lineName = '증명 제출',
  embedded = false,
}) => {
  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload?.length) {
      return (
        <div className="bg-card border border-border rounded-md shadow-gaming-lg p-3">
          <p className="text-sm font-medium text-foreground mb-2">{label}</p>
          {payload?.map((entry, index) => (
            <p key={index} className="text-xs text-muted-foreground">
              {entry?.name}: <span className="font-medium text-foreground data-text">{entry?.value}</span>
            </p>
          ))}
        </div>
      );
    }
    return null;
  };

  const chart = (
    <div className="w-full h-64 md:h-80" aria-label="Monthly Progress Trend Line Chart">
      <ResponsiveContainer width="100%" height="100%">
        <LineChart data={data} margin={{ top: 5, right: 5, left: -20, bottom: 5 }}>
          <CartesianGrid strokeDasharray="3 3" stroke="var(--color-border)" />
          <XAxis
            dataKey={xKey}
            stroke="var(--color-muted-foreground)"
            style={{ fontSize: '12px' }}
          />
          <YAxis
            stroke="var(--color-muted-foreground)"
            style={{ fontSize: '12px' }}
          />
          <Tooltip content={<CustomTooltip />} />
          <Legend wrapperStyle={{ fontSize: '12px', paddingTop: '10px' }} iconType="line" />
          <Line
            type="monotone"
            dataKey={lineKey}
            name={lineName}
            stroke="var(--color-primary)"
            strokeWidth={2}
            dot={{ fill: 'var(--color-primary)', r: 4 }}
            activeDot={{ r: 6 }}
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );

  if (embedded) return chart;

  return (
    <div className="bg-card rounded-lg shadow-gaming-md p-4 md:p-6">
      {title ? (
        <h3 className="text-lg md:text-xl font-heading font-semibold text-foreground mb-4 md:mb-6">
          {title}
        </h3>
      ) : null}
      {chart}
    </div>
  );
};

export default ProgressTrendChart;